angular.module('trainerWebApp.resources').factory('GroupsCtrlResolver',
  ['$q', '$route', 'groupsResource', 'usersResource', 'Validation', '$location', 'errorHandler', 'Auth', function ($q, $route, groupsResource, usersResource, Validation, $location, errorHandler, Auth) {

    return function () {
      var deferred = $q.defer();

      var pageName = $route.current.params.pageName || $route.current.pageName;

      var authorize = function () {
        return Auth.getRolePromise();
      };

      // let the controller handle the validate
      if (!Validation.validate()) {
        deferred.reject(false);
        return deferred.promise;
      }

      if (!pageName || pageName == 'manageGroups') {

        var usersResolve = usersResource.getUsers().$promise;

        var groupsResolve = groupsResource.getGroups().$promise;

        $q.all([authorize(), usersResolve, groupsResolve])
          .then(function (values) {
            return deferred.resolve({
              users: values[1],
              groups: values[2]
            });
        }, errorHandler.defaultServerErrorHandler());
      }

      return deferred.promise;
    };
  }]
);
